module.exports = __webpack_public_path__ + "static/img/credentials5.eeea9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/credentials5.png
// module id = J4S2
// module chunks = 0